import { useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useMediaQuery } from 'react-responsive';

import { DrawerComponent, MenuComponent } from '../../../_metronic/assets/ts/components'

import { useChat, setCurrentChat, deleteChat, setChats } from '../../context/chat';

import { Aside } from '../../layouts/Aside'
import { ChatContent } from '../../layouts/ChatContent'
import { Logo } from '../../components/Logo'
import { Chat } from './components/Chat';

import {ChatBase} from './ChatBase'

import { chatAPI } from '../../api';

interface LocationState {
  allChatsDeleted: boolean;
}

const ChatsBase = () => {

  const intl = useIntl()

  const navigate = useNavigate()

  const { state : {chats, currentChat}, dispatch } = useChat()

  const isMobile = useMediaQuery({ maxWidth: 991.98 });

  const { chatId } = useParams<{ chatId: string}>();

  const location = useLocation();

  const state = location.state as LocationState;

  useEffect(() => { 
    MenuComponent.reinitialization()
  }, [])

  useEffect(() => {
    if( state ){
      dispatch(setChats([]))
      dispatch(setCurrentChat())
    }
  }, [state])

  useEffect(() => {
    if( isMobile ){
      DrawerComponent.createInstances('[data-kt-drawer="true"]')
    }
    if( !chatId || chats.filter((chat) => chat.id == chatId).length > 0 ){
      dispatch(setCurrentChat(chatId))
    }else{
      goChat()
    }
  }, [chats, chatId])

  const goChat = (chatId?: string) => {
    navigate(`/c${chatId ? '/'+ chatId : ''}`, {replace: true})
  }

  const startNewChat = () => {
    goChat()
    if( isMobile ){
      DrawerComponent.handleDismiss()
    }
  }

  const handleDeleteChat = (chatIdToDelete: string) => {
    chatAPI.deleteChat(chatIdToDelete).then(() => {
      dispatch(deleteChat(chatIdToDelete))
      if( currentChat && chatIdToDelete == currentChat.id ){
        goChat()
      }
    })
  }

  return (
    <>
      <Aside withVersion={true}>
        <div className="px-2 mt-4">
          <div className="d-flex flex-stack p-3 mx-2 rounded start-new-chat cursor-pointer" onClick={startNewChat}>
            <Logo size={20}/>
            <div>{intl.formatMessage({id: 'chat.new'})}</div>
            <i className="fa-solid fa-edit fs-2"></i>
          </div>
        </div>
        <div className="px-2 overflow-y-auto chats">
          {
          chats && (chats.length === 0 
          ? 
            <div className="p-3 mx-2 ">
              <div className="text-center">
                <div className="text-center fs-8 text-muted fw-semibold">{intl.formatMessage({id: 'chat.none'})}</div>
              </div>
            </div>
          :
            chats.map((chat, index) => (
              <Chat 
                key={chat.id} 
                chat={chat} 
                previousChat={chats[index-1]} 
                goChat={()=>{
                  goChat(chat.id)
                }}
                handleDeleteChat={() => handleDeleteChat(chat.id)}
              />
            ))
          )
          }
        </div>
      </Aside>

      <ChatContent handleStartNewChat={startNewChat} >
        <ChatBase handleStartNewChat={startNewChat} handleDeleteChat={handleDeleteChat}/>
      </ChatContent>
    </>
  )
}

export {ChatsBase}
